/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../i18n';

export const useUtcFormat = () => {
  const now = DateTime.now();
  const { t } = useTranslation(Namespaces.Cluster);

  const utcLocal = useMemo(() => `${t('utc')}${now.toFormat('ZZ').split('').splice(0, 3).join('')}`, [t, now]);
  const utcServer = useMemo(
    () => `${t('utc')}${now.setZone('UTC').toFormat('ZZ').split('').splice(0, 3).join('')}`,
    [t, now],
  );

  return { utcLocal, utcServer };
};
